module.exports = __webpack_public_path__ + "static/media/logo-funssest.8620e6b6.png";